import type { Address } from 'viem'
import type { z } from 'zod'

import type { tokenLabelSchema } from '@/lib/orpc/schemas'
import type { ApiCoreToken } from '@/lib/upstream/core/routes/tokens'

export type TokenLabel = z.output<typeof tokenLabelSchema>

export function unknownTokenLabel(address: Address): TokenLabel {
  return { address, symbol: null, decimals: null, logoUri: null }
}

export function toTokenLabel(
  address: Address,
  token: Pick<ApiCoreToken, 'symbol' | 'decimals' | 'logo_uri'>
): TokenLabel {
  return {
    address,
    symbol: token.symbol,
    decimals: token.decimals,
    logoUri: token.logo_uri
  }
}
